module.exports = __webpack_public_path__ + "img/MasterDropsmartApp.0b275e4c.png";